function expApproach(current: number, target: number, dtSeconds: number, tauSeconds: number): number {
  return current + (target - current) * (1 - Math.exp(-dtSeconds / tauSeconds));
}

export interface FovKickOptions {
  kickDeg: number;
  attackTauS: number;
  releaseTauS: number;
  reducedMotion: boolean;
}

/**
 * Game Feel Polish Phase 4 — pure asymmetric-attack/release blend for the
 * sprint/dash FOV kick, extracted out of `DungeonInstanceScene
 * .followLocalPlayer()` so the blend math is unit-testable without a WebGL
 * context (unlike most of that class, which needs a real renderer to
 * construct at all) — same "extract the pure part" pattern as
 * `shoulder-camera-pose.ts`. `reducedMotion` forces the target to 0
 * unconditionally, so a user who prefers reduced motion never gets the kick
 * at all rather than a smaller version of it.
 */
export function stepFovKick(currentKickDeg: number, active: boolean, dtSeconds: number, options: FovKickOptions): number {
  const targetDeg = (!options.reducedMotion && active) ? options.kickDeg : 0;
  const tau = targetDeg > currentKickDeg ? options.attackTauS : options.releaseTauS;
  return expApproach(currentKickDeg, targetDeg, dtSeconds, tau);
}
